import { useEffect, useMemo, useState } from 'react'

const defaultOptions = {
  threshold: [0, 0.25, 0.5, 0.75, 1],
}

const useIntersectionObserver = ({ enabled = true, options, ref } = {}) => {
  const [ratio, setRatio] = useState(0)

  const obserOptions = useMemo(
    () => ({
      ...defaultOptions,
      ...(options ?? {}),
    }),
    [options]
  )
  useEffect(() => {
    if (!enabled || !ref?.current) return
    const element = ref.current
    const observer = new IntersectionObserver((entries) => {
      const ratio = entries[0]?.intersectionRatio
      setRatio(ratio)
    }, obserOptions)
    observer.observe(element)
    return () => observer.unobserve(element)
  }, [enabled, obserOptions, ref])

  return ratio
}

export default useIntersectionObserver
